module.exports = __webpack_public_path__ + "static/bg-pink-5ca3e5ad60b1c15ddea033c1069a804c.jpg";